import LessonMaterialsList from './component'
export default LessonMaterialsList
